import React from 'react';
import { CircularProgress, makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import { ITEMS_PER_PAGE_20 } from '@moderepo/mode-app-components';
import { useGetURLParamEntityIdAsNumber } from '../../utils/utils';
import { useSelectProject } from '../../utils/dataStateHooks';
import { useRitzTranslation } from '../../utils/customHooks';
import { AlertsListingContainer } from '.';


const useStyle = makeStyles(() => {
    return {
        root: {
        },
    };
}, { name: 'AlertsPage', index: 1 });



/**
 * This is a page that display all alerts.
 */
export const AlertsPage: React.FC = () => {

    // Get the params from the URL
    const projectId = useGetURLParamEntityIdAsNumber('projectId');
    const classes = useStyle();

    const project = useSelectProject(projectId);
    const { trans } = useRitzTranslation(project);


    return (
        <div className={clsx('page-main-content', classes.root)}>

            <div className="title-bar">
                <div className="title-bar-item title-text">
                    <div className="page-title">
                        {trans('page.title.alerts')}
                    </div>
                    <div className="page-subtitle">
                        {trans('page.subtitle.alerts')}
                    </div>
                </div>
            </div>

            {projectId && (
                <AlertsListingContainer
                    projectId={projectId}
                    itemsPerPage={ITEMS_PER_PAGE_20}
                    hiddenFields={{
                        id           : true,
                        conditionType: true,
                    }}
                />
            )}

            {!projectId && (
                <CircularProgress />
            )}
        </div>
    );
};
